(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-unificada-3x1"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaqTabs(root) {
      var tablists = root.querySelectorAll('[data-faq-tabs]');
      tablists.forEach(function (tablist) {
        if (tablist.dataset.faqTabsInit === 'true') return;
        tablist.dataset.faqTabsInit = 'true';

        var section = tablist.closest('.faq-uni');
        if (!section) return;

        var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
        if (!tabs.length) return;

        function panelFor(tab) {
          var id = tab.getAttribute('aria-controls');
          return id ? section.querySelector('#' + (window.CSS && CSS.escape ? CSS.escape(id) : id)) : null;
        }

        function activate(tab, setFocus) {
          tabs.forEach(function (t) {
            var selected = t === tab;
            t.setAttribute('aria-selected', selected ? 'true' : 'false');
            t.setAttribute('tabindex', selected ? '0' : '-1');
            t.classList.toggle('is-active', selected);
            var panel = panelFor(t);
            if (panel) {
              if (selected) {
                panel.removeAttribute('hidden');
              } else {
                panel.setAttribute('hidden', '');
              }
            }
          });
          if (setFocus) tab.focus();
        }

        tabs.forEach(function (tab, index) {
          tab.addEventListener('click', function () {
            activate(tab, false);
          });
          tab.addEventListener('keydown', function (e) {
            var key = e.key;
            var newIndex = null;
            if (key === 'ArrowRight' || key === 'ArrowDown') {
              newIndex = (index + 1) % tabs.length;
            } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
              newIndex = (index - 1 + tabs.length) % tabs.length;
            } else if (key === 'Home') {
              newIndex = 0;
            } else if (key === 'End') {
              newIndex = tabs.length - 1;
            }
            if (newIndex !== null) {
              e.preventDefault();
              activate(tabs[newIndex], true);
            }
          });
        });

        // JS toma el control: oculta todos los paneles menos el activo por
        // defecto (marcado en el markup). Hasta aquí, todos estaban visibles.
        var defaultTab = tabs.filter(function (t) {
          return t.getAttribute('aria-selected') === 'true';
        })[0] || tabs[0];
        activate(defaultTab, false);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initFaqTabs(document);
      });
    } else {
      initFaqTabs(document);
    }

    document.addEventListener('shopify:section:load', function (e) {
      initFaqTabs(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gente-usando-skindion"] && !Shopify.designMode) return;
  try {
    
  /* ============================================================
     gente-usando-skindion — visor UGC tipo TikTok (POPUP + snap).
     Vanilla JS, self-contained (NO depende de m3x1.js). La a11y del
     modal MODELA initZoom/initPopup de m3x1.js: role=dialog aria-modal,
     focus-trap, ESC, overlay-click, scroll-lock, restaura foco.
     Self-initializing, idempotente (guard dataset), re-init en
     shopify:section:load scoped a e.target.

     🔴 LCP / lazy: los slides del visor son <img> posters (lazy); NINGÚN
     <video src> sale en el markup. Un IntersectionObserver con root = el
     scroller detecta el slide centrado e INYECTA un <video> SÓLO en él;
     al cambiar de slide, los demás se pausan y se ELIMINAN (src + nodo)
     → a lo más ~1-2 videos cargados a la vez. El visor arranca hidden →
     sus <img> NO se descargan hasta abrir. La tira (abajo) es independiente.
     ============================================================ */
  (function () {
    'use strict';

    var FOCUSABLE =
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

    function initSection(root) {
      if (!root || root.dataset.gusInit === '1') return;

      var strip = root.querySelector('[data-gus-strip]');
      var viewer = root.querySelector('[data-gus-viewer]');
      if (!strip || !viewer) return;

      var triggers = Array.prototype.slice.call(
        strip.querySelectorAll('[data-gus-open]')
      );
      if (triggers.length === 0) return;

      root.dataset.gusInit = '1';

      var dialog = viewer.querySelector('[data-gus-dialog]');
      var overlay = viewer.querySelector('[data-gus-overlay]');
      var scroller = viewer.querySelector('[data-gus-scroller]');
      var slides = scroller
        ? Array.prototype.slice.call(scroller.querySelectorAll('[data-gus-slide]'))
        : [];
      var dotsWrap = viewer.querySelector('[data-gus-dots]');
      var closeBtn = viewer.querySelector('[data-gus-close]');
      var prevBtn = viewer.querySelector('[data-gus-prev]');
      var nextBtn = viewer.querySelector('[data-gus-next]');
      var soundBtn = viewer.querySelector('[data-gus-sound]');

      if (!dialog || !scroller || slides.length === 0) return;

      var current = -1;
      var lastFocused = null;
      var keydownHandler = null;
      var soundOn = false;
      var scrollObserver = null;   // IO del scroller (slide centrado)
      var dots = [];
      var scrollEndHandler = null;   // Red de seguridad: scrollend / scroll debounced
      var scrollEndTimer = null;     // Timeout del debounce (scroll sin scrollend)

      /* ---- Autoplay lazy de miniaturas (muted-loop on scroll-into-view) ----
         🔴 LCP: ningún <video> sale en el markup del servidor. El observer crea
         el <video> SÓLO cuando la miniatura entra al viewport y lo destruye al
         salir → a lo más ~2-3 videos cargados a la vez (los visibles en la tira
         horizontal). Respeta prefers-reduced-motion: si lo prefiere, NO hay
         autoplay y se mantiene el poster + glifo play actuales. */
      var prefersReducedMotion = false;
      try {
        prefersReducedMotion =
          window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches === true;
      } catch (e) {
        prefersReducedMotion = false;
      }
      var autoplaySupported =
        !prefersReducedMotion && typeof window.IntersectionObserver === 'function';
      var thumbObserver = null;

      /* ---- Construye los dots (uno por slide) una sola vez -------------- */
      function buildDots() {
        if (!dotsWrap || dots.length > 0) return;
        // Con 0 o 1 slides, un solo dot (o ninguno) no comunica posición; omitir.
        if (slides.length <= 1) {
          dotsWrap.setAttribute('data-count', '0');
          return;
        }
        // Oculta los dots si son demasiados (una columna larga estorba; el snap
        // ya comunica posición). Umbral conservador.
        if (slides.length > 10) {
          dotsWrap.setAttribute('data-count', '0');
          return;
        }
        for (var i = 0; i < slides.length; i++) {
          var dot = document.createElement('span');
          dot.className = 'gus__viewer-dot';
          dotsWrap.appendChild(dot);
          dots.push(dot);
        }
        dotsWrap.setAttribute('data-count', String(slides.length));
      }

      function syncDots(index) {
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('is-active', i === index);
        }
      }

      /* ---- Inyecta el <video> de UN slide (lazy) ----------------------- */
      function startSlideVideo(slide) {
        if (!slide || slide._gusVideo) return;
        var src = slide.getAttribute('data-video-src');
        if (!src) return;
        var poster = slide.getAttribute('data-video-poster') || '';
        var media = slide.querySelector('.gus__slide-media');
        if (!media) return;

        var v = document.createElement('video');
        v.className = 'gus__slide-video';
        v.muted = !soundOn;
        v.defaultMuted = !soundOn;
        v.loop = true;
        v.playsInline = true;
        if (!soundOn) v.setAttribute('muted', '');
        v.setAttribute('loop', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('preload', 'auto');
        v.setAttribute('disablepictureinpicture', '');
        v.setAttribute('aria-hidden', 'true');   // decorativo; el video no es foco
        v.tabIndex = -1;
        if (poster) v.setAttribute('poster', poster);
        v.src = src;

        // Encima del poster <img> (queda como base, CLS-safe).
        media.appendChild(v);
        slide._gusVideo = v;

        var reveal = function () {
          v.classList.add('is-playing');
        };
        if (v.readyState >= 2) {
          reveal();
        } else {
          v.addEventListener('playing', reveal, { once: true });
          v.addEventListener('loadeddata', reveal, { once: true });
        }

        try {
          v.load();
        } catch (e) {
          /* no-op */
        }
      }

      /* ---- Pausa + elimina el <video> de UN slide (libera descarga) ---- */
      function clearSlideVideo(slide) {
        if (!slide || !slide._gusVideo) return;
        var v = slide._gusVideo;
        try {
          v.pause();
        } catch (e) {
          /* no-op */
        }
        v.classList.remove('is-playing');
        v.removeAttribute('src');
        try {
          v.load();
        } catch (e) {
          /* no-op */
        }
        if (v.parentNode) v.parentNode.removeChild(v);
        slide._gusVideo = null;
      }

      /* ---- Elimina TODOS los <video> del visor (cierre / teardown) ----- */
      function clearAllSlideVideos() {
        slides.forEach(clearSlideVideo);
      }

      /* ---- Activa el slide `index`: inyecta su video, limpia los demás,
         reproduce el activo y sincroniza UI. 🔴 Mantiene SÓLO el video activo
         cargado (≤1-2 a la vez): es la postura LCP más segura dentro del rango
         que permite la spec ("activo ± 1, máx 1-2"). ------------------------- */
      function activate(index) {
        if (index < 0) index = 0;
        if (index > slides.length - 1) index = slides.length - 1;
        if (index === current) {
          // Re-asegura reproducción (p. ej. tras volver a entrar al viewport).
          var same = slides[index] && slides[index]._gusVideo;
          if (same) {
            same.muted = !soundOn;
            playSafe(same);
          }
          return;
        }
        current = index;

        // Limpia cualquier video que no sea el activo (libera buffers).
        slides.forEach(function (slide, i) {
          if (i !== index && slide._gusVideo) clearSlideVideo(slide);
        });

        var active = slides[index];
        startSlideVideo(active);
        if (active && active._gusVideo) {
          active._gusVideo.muted = !soundOn;
          playSafe(active._gusVideo);
        }

        syncDots(index);
        updateNavState();
      }

      function playSafe(v) {
        if (!v) return;
        var p;
        try {
          p = v.play();
        } catch (e) {
          return;
        }
        if (p && typeof p.catch === 'function') {
          p.catch(function () {
            // Autoplay bloqueado (raro estando muted) — el póster sigue visible.
          });
        }
      }

      function updateNavState() {
        var prevDisabled = current <= 0;
        var nextDisabled = current >= slides.length - 1;
        // Si el botón con foco se va a deshabilitar (extremo con teclado), mueve
        // el foco a un control vivo ANTES — nadie queda atrapado en un disabled.
        var active = document.activeElement;
        if (prevBtn && prevDisabled && active === prevBtn) {
          (nextBtn && !nextDisabled ? nextBtn : closeBtn || dialog).focus();
        } else if (nextBtn && nextDisabled && active === nextBtn) {
          (prevBtn && !prevDisabled ? prevBtn : closeBtn || dialog).focus();
        }
        if (prevBtn) prevBtn.disabled = prevDisabled;
        if (nextBtn) nextBtn.disabled = nextDisabled;
      }

      function applySound() {
        // Aplica al video activo; el estado persiste entre slides (lo lee
        // startSlideVideo/activate al inyectar/reproducir el siguiente).
        var active = slides[current] && slides[current]._gusVideo;
        if (active) active.muted = !soundOn;
        if (soundBtn) {
          soundBtn.classList.toggle('is-on', soundOn);
          soundBtn.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
          soundBtn.setAttribute(
            'aria-label',
            soundOn ? 'Silenciar video' : 'Activar sonido'
          );
        }
      }

      /* ---- Navegación: hace snap al slide adyacente (teclas / prev-next).
         El observer del scroller detecta la llegada y activa el video. ------- */
      function scrollToIndex(index) {
        if (index < 0 || index > slides.length - 1) return;
        var target = slides[index];
        if (!target) return;
        var behavior = prefersReducedMotion ? 'auto' : 'smooth';
        target.scrollIntoView({ behavior: behavior, block: 'start' });
      }

      function go(delta) {
        var next = current + delta;
        if (next < 0 || next > slides.length - 1) return;
        scrollToIndex(next);
      }

      /* ---- Observer del scroller: detecta el slide centrado ------------- */
      function buildScrollObserver() {
        if (typeof window.IntersectionObserver !== 'function') return null;
        return new window.IntersectionObserver(
          function (entries) {
            // El slide con mayor ratio que cruce el umbral es el activo.
            var best = null;
            var bestRatio = 0;
            entries.forEach(function (entry) {
              if (entry.isIntersecting && entry.intersectionRatio > bestRatio) {
                bestRatio = entry.intersectionRatio;
                best = entry.target;
              }
            });
            if (best) {
              var idx = slides.indexOf(best);
              if (idx !== -1) activate(idx);
            }
          },
          { root: scroller, rootMargin: '0px', threshold: 0.6 }
        );
      }

      /* ---- Red de seguridad I-1: garantiza que tras soltar el scroll el slide
         centrado siempre se activa. Usa scrollend cuando está disponible; en
         navegadores sin scrollend usa un listener scroll debounced (~120ms).
         Solo activa el índice calculado si difiere de current (evita re-renders).
         El listener (y cualquier timer pendiente) se cancela en close() y en el
         teardown hook para cero leaks. ------------------------------------ */
      function onScrollSettle() {
        if (!scroller) return;
        var idx = Math.round(scroller.scrollTop / scroller.clientHeight);
        if (idx < 0) idx = 0;
        if (idx > slides.length - 1) idx = slides.length - 1;
        if (idx !== current) activate(idx);
      }

      function buildScrollSafetyNet() {
        if (!scroller) return;
        if ('onscrollend' in scroller) {
          // scrollend es el evento nativo: dispara UNA SOLA VEZ cuando el scroll
          // (incluyendo el snap inertial) se asienta. Ideal para móvil + desktop.
          scrollEndHandler = onScrollSettle;
          scroller.addEventListener('scrollend', scrollEndHandler);
        } else {
          // Fallback para navegadores sin scrollend: debounce 120ms sobre scroll.
          scrollEndHandler = function () {
            if (scrollEndTimer) window.clearTimeout(scrollEndTimer);
            scrollEndTimer = window.setTimeout(onScrollSettle, 120);
          };
          scroller.addEventListener('scroll', scrollEndHandler, { passive: true });
        }
      }

      function removeScrollSafetyNet() {
        if (!scroller || !scrollEndHandler) return;
        scroller.removeEventListener('scrollend', scrollEndHandler);
        scroller.removeEventListener('scroll', scrollEndHandler);
        scrollEndHandler = null;
        if (scrollEndTimer) {
          window.clearTimeout(scrollEndTimer);
          scrollEndTimer = null;
        }
      }

      /* ---- Abrir / cerrar (mirror de initZoom/initPopup) -------- */
      function open(index, trigger) {
        if (!viewer.hidden) return;
        lastFocused = trigger || document.activeElement;

        // Pausa los videos de la tira (quedan tapados por el scrim del visor).
        pauseAllThumbs();

        viewer.hidden = false;
        // Reflow para que la transición corra desde el estado oculto y para que
        // el scroller tenga dimensiones antes de posicionarlo.
        void viewer.offsetWidth;
        viewer.classList.add('is-open');
        document.documentElement.classList.add('gus-scroll-lock');

        // Sonido arranca apagado en cada apertura (autoplay exige muted).
        soundOn = false;
        applySound();

        buildDots();

        // I-3: con 1 solo slide los botones prev/next no aportan; ocultarlos.
        if (slides.length <= 1) {
          if (prevBtn) prevBtn.hidden = true;
          if (nextBtn) nextBtn.hidden = true;
        } else {
          if (prevBtn) prevBtn.hidden = false;
          if (nextBtn) nextBtn.hidden = false;
        }

        // I-2: posiciona el scroller con scrollIntoView (respeta el layout
        // derivado de aspect-ratio, que puede no estar resuelto aún). Lo
        // envolvemos en rAF para dar al browser un frame con el visor visible
        // y con dimensiones antes de intentar el scroll.
        current = -1;
        requestAnimationFrame(function () {
          // Si el visor se cerró antes de que este frame disparara, aborta:
          // evita inyectar un <video> huérfano que ningún observer limpiará.
          // open() añade is-open ANTES de programar el rAF; close() la remueve
          // de forma síncrona al inicio → el guard es fiable en ambas rutas.
          if (!viewer.classList.contains('is-open')) return;
          if (slides[index]) {
            slides[index].scrollIntoView({ block: 'start', behavior: 'auto' });
          }
          // Activa el video del slide correcto de inmediato (no espera al IO).
          activate(index);
        });

        // Conecta el IO del scroller (toma el control una vez activo el visor).
        scrollObserver = buildScrollObserver();
        if (scrollObserver) {
          slides.forEach(function (slide) {
            scrollObserver.observe(slide);
          });
        }
        // I-1: red de seguridad scroll settle (cubre swipe parcial + trackpad).
        buildScrollSafetyNet();

        keydownHandler = onKeydown;
        document.addEventListener('keydown', keydownHandler, true);

        // Mueve el foco al diálogo (el botón cerrar es una primera parada segura).
        (closeBtn || dialog).focus();
      }

      function close() {
        if (viewer.hidden) return;
        viewer.classList.remove('is-open');
        document.documentElement.classList.remove('gus-scroll-lock');

        if (keydownHandler) {
          document.removeEventListener('keydown', keydownHandler, true);
          keydownHandler = null;
        }

        // I-1: cancela la red de seguridad de scroll (evita que dispare tras cerrar).
        removeScrollSafetyNet();

        // Desconecta el observer del scroller y limpia todos los <video>.
        if (scrollObserver) {
          try {
            scrollObserver.disconnect();
          } catch (e) {
            /* no-op */
          }
          scrollObserver = null;
        }
        clearAllSlideVideos();
        current = -1;

        // Espera la transición antes de ocultar; luego reanuda los videos de la
        // tira que sigan visibles (su observer conservó sus <video>).
        window.setTimeout(function () {
          viewer.hidden = true;
          if (autoplaySupported) resumeVisibleThumbs();
        }, 200);

        // Restaura el foco a la miniatura de origen (NO mueve el scroll de la
        // página: el scrim fixed lo preservó; sólo devolvemos el foco).
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
        lastFocused = null;
      }

      function trapFocus(e) {
        var focusables = Array.prototype.slice
          .call(dialog.querySelectorAll(FOCUSABLE))
          .filter(function (el) {
            return el.offsetParent !== null || el === document.activeElement;
          });
        if (focusables.length === 0) {
          e.preventDefault();
          dialog.focus();
          return;
        }
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        var active = document.activeElement;

        if (e.shiftKey) {
          if (active === first || !dialog.contains(active)) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (active === last || !dialog.contains(active)) {
            e.preventDefault();
            first.focus();
          }
        }
      }

      function onKeydown(e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          e.preventDefault();
          close();
        } else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          e.preventDefault();
          go(1);
        } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          e.preventDefault();
          go(-1);
        } else if (e.key === 'Tab') {
          trapFocus(e);
        }
      }

      /* ---- Listeners ------------------------------------------- */
      triggers.forEach(function (trigger, index) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          open(index, trigger);
        });
      });

      if (closeBtn) closeBtn.addEventListener('click', close);
      if (overlay) overlay.addEventListener('click', close);
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          go(-1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          go(1);
        });
      }
      if (soundBtn) {
        soundBtn.addEventListener('click', function () {
          soundOn = !soundOn;
          applySound();
        });
      }

      /* ---- Crear / destruir el <video> de una miniatura (lazy) --------- */
      function startThumbVideo(thumb) {
        if (!thumb || thumb._gusVideo) return;
        var src = thumb.getAttribute('data-video-src');
        if (!src) return;
        var poster = thumb.getAttribute('data-video-poster') || '';

        var v = document.createElement('video');
        v.className = 'gus__thumb-video';
        v.muted = true;            // iOS exige muted (+playsinline) para autoplay.
        v.defaultMuted = true;
        v.loop = true;
        v.playsInline = true;
        v.setAttribute('muted', '');
        v.setAttribute('loop', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('preload', 'auto');
        v.setAttribute('disablepictureinpicture', '');
        v.setAttribute('aria-hidden', 'true');   // decorativo; la acción es el botón.
        v.tabIndex = -1;
        if (poster) v.setAttribute('poster', poster);
        v.src = src;

        // Inserta el video justo DESPUÉS del poster <img> (queda como base, bajo
        // el play/expand/autor en orden de pintado). insertBefore(v, null) === append.
        var img = thumb.querySelector('.gus__thumb-img');
        if (img) {
          thumb.insertBefore(v, img.nextSibling);
        } else {
          thumb.insertBefore(v, thumb.firstChild);
        }
        thumb._gusVideo = v;

        // Desvanece al empezar a reproducir (sin flash; el poster <img> queda debajo).
        var reveal = function () {
          v.classList.add('is-playing');
        };
        if (v.readyState >= 2) {
          reveal();
        } else {
          v.addEventListener('playing', reveal, { once: true });
          v.addEventListener('loadeddata', reveal, { once: true });
        }

        try {
          v.load();
        } catch (e) {
          /* no-op */
        }
        var p = v.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () {
            // Autoplay bloqueado (raro estando muted) — el poster sigue visible.
          });
        }
      }

      function stopThumbVideo(thumb) {
        if (!thumb || !thumb._gusVideo) return;
        var v = thumb._gusVideo;
        try {
          v.pause();
        } catch (e) {
          /* no-op */
        }
        // Vaciar src + load() corta la descarga; remover el nodo libera memoria.
        v.classList.remove('is-playing');
        v.removeAttribute('src');
        try {
          v.load();
        } catch (e) {
          /* no-op */
        }
        if (v.parentNode) v.parentNode.removeChild(v);
        thumb._gusVideo = null;
      }

      /* Pausa todos los videos de la tira (al abrir el visor están tapados) */
      function pauseAllThumbs() {
        triggers.forEach(function (thumb) {
          if (thumb._gusVideo) {
            try {
              thumb._gusVideo.pause();
            } catch (e) {
              /* no-op */
            }
          }
        });
      }

      /* Reanuda los que sigan visibles (el observer mantuvo sus <video>) */
      function resumeVisibleThumbs() {
        triggers.forEach(function (thumb) {
          if (thumb._gusVideo) {
            var p = thumb._gusVideo.play();
            if (p && typeof p.catch === 'function') {
              p.catch(function () {});
            }
          }
        });
      }

      /* ---- Observer: autoplay sólo de las miniaturas visibles ---------- */
      if (autoplaySupported) {
        // Marca de estado para el CSS (oculta el play central, muestra "expandir").
        strip.classList.add('is-autoplay');

        thumbObserver = new window.IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var thumb = entry.target;
              if (entry.isIntersecting) {
                // No arranques videos mientras el visor está abierto (tapados).
                if (viewer.hidden) startThumbVideo(thumb);
              } else {
                stopThumbVideo(thumb);
              }
            });
          },
          { root: null, rootMargin: '0px', threshold: 0.3 }
        );

        triggers.forEach(function (thumb) {
          thumbObserver.observe(thumb);
        });

        // Guarda el observer en el root para desconectarlo en re-init/unload.
        root._gusThumbObserver = thumbObserver;
      }

      // Hook de teardown del VISOR (el scrollObserver, la red de seguridad y los
      // <video> de los slides son scoped a este closure → teardownSection los
      // libera vía esta función).
      root._gusViewerTeardown = function () {
        // I-1: cancela la red de seguridad de scroll.
        removeScrollSafetyNet();
        if (scrollObserver) {
          try {
            scrollObserver.disconnect();
          } catch (e) {
            /* no-op */
          }
          scrollObserver = null;
        }
        clearAllSlideVideos();
        if (keydownHandler) {
          document.removeEventListener('keydown', keydownHandler, true);
          keydownHandler = null;
        }
        document.documentElement.classList.remove('gus-scroll-lock');
      };
    }

    function boot() {
      var roots = document.querySelectorAll('.gus');
      Array.prototype.forEach.call(roots, initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    function teardownSection(root) {
      if (!root) return;
      // Desconecta el observer del VISOR (scroller) y limpia sus <video>.
      if (typeof root._gusViewerTeardown === 'function') {
        try {
          root._gusViewerTeardown();
        } catch (e) {
          /* no-op */
        }
        root._gusViewerTeardown = null;
      }
      // Desconecta el observer de autoplay y limpia los <video> de la tira.
      if (root._gusThumbObserver) {
        try {
          root._gusThumbObserver.disconnect();
        } catch (e) {
          /* no-op */
        }
        root._gusThumbObserver = null;
      }
      // M-2: limpia el guard de init para que un eventual re-load no haga
      // early-return y deje la sección muerta (idempotencia en unload/load).
      try {
        delete root.dataset.gusInit;
      } catch (e) {
        root.dataset.gusInit = '';
      }
      var thumbs = root.querySelectorAll
        ? root.querySelectorAll('[data-gus-open]')
        : [];
      Array.prototype.forEach.call(thumbs, function (thumb) {
        var v = thumb._gusVideo;
        if (v) {
          try {
            v.pause();
          } catch (e) {
            /* no-op */
          }
          v.removeAttribute('src');
          try {
            v.load();
          } catch (e) {
            /* no-op */
          }
          if (v.parentNode) v.parentNode.removeChild(v);
          thumb._gusVideo = null;
        }
      });
    }

    // Re-init cuando el Theme Editor / Section Rendering API re-renderiza.
    document.addEventListener('shopify:section:load', function (e) {
      var target = e.target || document;
      if (target.classList && target.classList.contains('gus')) {
        initSection(target);
        return;
      }
      var roots = target.querySelectorAll ? target.querySelectorAll('.gus') : [];
      Array.prototype.forEach.call(roots, initSection);
    });

    // Al descargar la sección (Theme Editor) libera observer + videos de la tira.
    document.addEventListener('shopify:section:unload', function (e) {
      var target = e.target || document;
      if (target.classList && target.classList.contains('gus')) {
        teardownSection(target);
        return;
      }
      var roots = target.querySelectorAll ? target.querySelectorAll('.gus') : [];
      Array.prototype.forEach.call(roots, teardownSection);
    });

    /* ---- Flechas + barra de progreso del carril (Mau 2026-07-04) -----
       Flechas: scroll por click (2 cards por paso) + disabled en los
       extremos (CSS las desvanece); solo se ven >=1024px. Barra de
       progreso: fill rosa = porción ya vista del carril (scrollLeft +
       viewport) / total — corre en TODOS los breakpoints. Sync por rAF
       (fluido durante el scroll). Cada pieza es opcional: la barra
       funciona aunque falten flechas y viceversa. --------------------- */
    function initStripNav(scope) {
      var wraps = (scope || document).querySelectorAll('[data-gus-wrap]');
      Array.prototype.forEach.call(wraps, function (wrap) {
        if (wrap.dataset.gusNavInit === '1') return;
        wrap.dataset.gusNavInit = '1';
        var strip = wrap.querySelector('[data-gus-strip]');
        var prev = wrap.querySelector('[data-gus-prev]');
        var next = wrap.querySelector('[data-gus-next]');
        var bar = wrap.querySelector('[data-gus-progress]');
        if (!strip) return;

        function step() {
          var card = strip.querySelector('.gus__thumb');
          var w = card ? card.getBoundingClientRect().width : 260;
          return (w + 16) * 2; // dos cards por click
        }
        function sync() {
          var max = strip.scrollWidth - strip.clientWidth;
          if (prev) prev.disabled = strip.scrollLeft <= 2;
          if (next) next.disabled = strip.scrollLeft >= max - 2;
          if (bar) {
            var frac = strip.scrollWidth > 0
              ? (strip.scrollLeft + strip.clientWidth) / strip.scrollWidth
              : 1;
            bar.style.width = Math.min(100, Math.max(0, frac * 100)) + '%';
          }
        }
        if (prev) {
          prev.addEventListener('click', function () {
            strip.scrollBy({ left: -step(), behavior: 'smooth' });
          });
        }
        if (next) {
          next.addEventListener('click', function () {
            strip.scrollBy({ left: step(), behavior: 'smooth' });
          });
        }
        var raf = null;
        function scheduleSync() {
          if (raf) return;
          raf = window.requestAnimationFrame(function () {
            raf = null;
            sync();
          });
        }
        strip.addEventListener('scroll', scheduleSync, { passive: true });
        window.addEventListener('resize', scheduleSync);
        sync();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initStripNav(document);
      });
    } else {
      initStripNav(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      initStripNav(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-bar-mudanza"] && !Shopify.designMode) return;
  try {
    
  (function () {

    function withThousands(n) {
      // Separador de miles sin depender de Intl (entorno viejo-safe).
      return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    // 'now' efectivo. ?pbm_now=<ISO|epoch-ms> permite previsualizar estados
    // futuros del contador/cierre (ej. ?pbm_now=2026-07-21T13:20:00-06:00).
    // Solo cambia lo que ESTE visitante ve; no afecta a nadie más ni a datos.
    function effectiveNow() {
      var m = /[?&]pbm_now=([^&]+)/.exec(window.location.search);
      if (m) {
        var raw = decodeURIComponent(m[1]);
        var t = /^\d+$/.test(raw) ? parseInt(raw, 10) : Date.parse(raw);
        if (!isNaN(t)) { return t; }
      }
      return Date.now();
    }

    // ── Jitter determinista (xorshift-32 sobre i) → [-0.25, +0.25] ────────
    // Mismo i → mismo valor para todos los visitantes (NO Math.random).
    function jitter(i) {
      var h = (i + 1) >>> 0; // evitar i=0 → h=0
      h = Math.imul(h ^ (h >>> 16), 0x45d9f3b) >>> 0;
      h = Math.imul(h ^ (h >>> 16), 0x45d9f3b) >>> 0;
      h = (h ^ (h >>> 16)) >>> 0;
      return (h / 0xffffffff) * 0.5 - 0.25;
    }

    // ── Multiplicador por hora del día (hod 0-23) ─────────────────────────
    // Madrugada (0-6) devuelve 0: esas horas se consumen a rate fijo aparte.
    function hourMult(hod) {
      if (hod >= 9 && hod <= 12) { return 2.0; } // pico mañana 9am-1pm
      if (hod >= 19 && hod <= 22) { return 2.0; } // pico noche 7pm-11pm
      if (hod >= 13 && hod <= 18) { return 1.0; } // tarde
      if (hod === 7 || hod === 8) { return 0.8; } // rampa mañana
      if (hod === 23) { return 0.6; } // cierre
      return 0; // 0-6 madrugada
    }

    // ── Multiplicador por fase (dayIdx 0-based desde el día de inicio) ────
    function phaseMult(dayIdx) {
      if (dayIdx <= 1) { return 1.4; } // arranque
      if (dayIdx <= 5) { return 2.0; } // pico fin de semana
      if (dayIdx <= 8) { return 0.7; } // estabiliza
      if (dayIdx <= 11) { return 1.5; } // repunte
      if (dayIdx <= 15) { return 0.7; } // meseta
      return 2.2; // empujón final
    }

    var MAD_RATE = 3; // madrugada (hod 0-6): 3 unidades/hora fijas (múltiplo de 3, "poquito")

    // ── Consumo acumulado (continuo) hasta 'now' ──────────────────────────
    // El tramo diurno se normaliza para que el consumo total sobre [start,end)
    // = depletable. Madrugada = rate fijo (no escala con la fase). Monótono.
    function consumedAt(now, startTime, endTime, depletable) {
      var STEP = 3600000; // 1 hora
      var totalSteps = Math.max(1, Math.round((endTime - startTime) / STEP));

      // Pass 1: total madrugada (M) y suma de pesos diurnos (Wd).
      var M = 0, Wd = 0, i, hod, day;
      for (i = 0; i < totalSteps; i++) {
        hod = i % 24;
        if (hod <= 6) {
          M += MAD_RATE;
        } else {
          day = Math.floor(i / 24);
          Wd += phaseMult(day) * hourMult(hod) * (1 + jitter(i));
        }
      }
      var daytimeBudget = depletable - M;
      if (daytimeBudget < 0) { daytimeBudget = 0; }
      var scaleD = Wd > 0 ? daytimeBudget / Wd : 0;

      function rate(idx) {
        var hd = idx % 24;
        if (hd <= 6) { return MAD_RATE; }
        var dy = Math.floor(idx / 24);
        return phaseMult(dy) * hourMult(hd) * (1 + jitter(idx)) * scaleD;
      }

      // Pass 2: acumular horas completas + fracción de la hora actual.
      var hElapsed = (now - startTime) / STEP;
      if (hElapsed <= 0) { return 0; }
      var full = Math.floor(hElapsed);
      var frac = hElapsed - full;
      if (full > totalSteps) { full = totalSteps; frac = 0; }

      var consumed = 0;
      for (i = 0; i < full; i++) { consumed += rate(i); }
      if (full < totalSteps && frac > 0) { consumed += frac * rate(full); }
      if (consumed > depletable) { consumed = depletable; }
      return consumed;
    }

    function roundTo3(x) { return 3 * Math.round(x / 3); }

    // ── Contador de lote ──────────────────────────────────────────────────
    // AUTO   (start+end+total): curva horaria → número en múltiplos de 3.
    // MANUAL (sin start/end): solo separador de miles al server-rendered.
    function initCounter(el) {
      if (el.dataset.pbmCounterInit === '1') { return; }
      el.dataset.pbmCounterInit = '1';

      var numEl = el.querySelector('[data-counter-num]');
      if (!numEl) { return; }

      // Total (Y) estático → solo separador de miles.
      var totEl = el.querySelector('[data-counter-total-num]');
      if (totEl) {
        var tv = parseInt((totEl.textContent || '').replace(/[^\d]/g, ''), 10);
        if (!isNaN(tv)) { totEl.textContent = withThousands(tv); }
      }

      var hasAuto = el.hasAttribute('data-counter-start') && el.hasAttribute('data-counter-end');

      // MANUAL: separador de miles y termina.
      if (!hasAuto) {
        var mv = parseInt((numEl.textContent || '').replace(/[^\d]/g, ''), 10);
        if (!isNaN(mv)) { numEl.textContent = withThousands(mv); }
        return;
      }

      var total = parseInt(el.getAttribute('data-counter-total'), 10);
      var floorRaw = parseInt(el.getAttribute('data-counter-floor'), 10);
      var startTime = Date.parse(el.getAttribute('data-counter-start'));
      var endTime = Date.parse(el.getAttribute('data-counter-end'));

      // Datos inválidos → dejar server-rendered con separador de miles.
      if (isNaN(total) || isNaN(startTime) || isNaN(endTime) || endTime <= startTime) {
        var fv = parseInt((numEl.textContent || '').replace(/[^\d]/g, ''), 10);
        if (!isNaN(fv)) { numEl.textContent = withThousands(fv); }
        return;
      }
      if (isNaN(floorRaw) || floorRaw < 0) { floorRaw = 9; }

      // Pista en múltiplos de 3: arranca en el mayor múltiplo de 3 ≤ total,
      // termina en el piso (redondeado a múltiplo de 3, mínimo 3).
      var startDisplay = 3 * Math.floor(total / 3);
      var floor3 = 3 * Math.round(floorRaw / 3);
      if (floor3 < 3) { floor3 = 3; }
      if (floor3 > startDisplay) { floor3 = startDisplay; }
      var depletable = startDisplay - floor3;

      var now = effectiveNow();
      var displayed;

      // Cierre programado (overtime): tras el fin de la promo, seguir un
      // cronograma de cierre en vez del piso normal (valor 1 → valor 2 en
      // data-overtime-step). Bypassa el clamp del piso a propósito.
      var otStepTime = Date.parse(el.getAttribute('data-overtime-step'));
      var otV1 = parseInt(el.getAttribute('data-overtime-1'), 10);
      var otV2 = parseInt(el.getAttribute('data-overtime-2'), 10);
      var overtime = false;
      if (now >= endTime && !isNaN(otV1)) {
        overtime = true;
        if (!isNaN(otStepTime) && !isNaN(otV2) && now >= otStepTime) {
          displayed = otV2;
        } else {
          displayed = otV1;
        }
      }

      if (!overtime) {
        if (now <= startTime) {
          displayed = startDisplay;
        } else if (now >= endTime) {
          displayed = floor3;
        } else {
          var consumed = consumedAt(now, startTime, endTime, depletable);
          displayed = startDisplay - roundTo3(consumed);
        }
        // Clamp [floor3, startDisplay] — JS nunca sube sobre el server-render.
        if (displayed > startDisplay) { displayed = startDisplay; }
        if (displayed < floor3) { displayed = floor3; }
      }

      numEl.textContent = withThousands(displayed);
    }

    // ── Timer 48h (opción C) ──────────────────────────────────────────────
    // Muestra la fila del timer SOLO dentro de la ventana [timer_end - window,
    // timer_end) y cuenta regresiva a timer_end. Fuera de la ventana queda
    // oculto (server-render hidden). ?timer_preview=1 lo fuerza visible con un
    // demo de 47:58:12 (para QA antes de que llegue la ventana real).
    function initTimer(el) {
      if (el.dataset.pbmTimerInit === '1') { return; }
      el.dataset.pbmTimerInit = '1';

      var endTime = Date.parse(el.getAttribute('data-timer-end'));
      var windowHours = parseInt(el.getAttribute('data-timer-window'), 10);
      if (isNaN(endTime)) { return; }
      if (isNaN(windowHours) || windowHours <= 0) { windowHours = 48; }

      var previewMode = /[?&]timer_preview=1/.test(window.location.search);
      var DEMO_MS = (47 * 3600 + 58 * 60 + 12) * 1000;
      var effNow = previewMode ? (endTime - DEMO_MS) : Date.now();
      var windowStart = endTime - windowHours * 3600000;

      // Fuera de la ventana (y sin preview) → queda oculto.
      if (!previewMode && (effNow < windowStart || effNow >= endTime)) { return; }

      var hEl = el.querySelector('[data-timer-h]');
      var mEl = el.querySelector('[data-timer-m]');
      var sEl = el.querySelector('[data-timer-s]');
      if (!hEl || !mEl || !sEl) { return; }

      function p2(n) { return (n < 10 ? '0' : '') + n; }
      var remaining = Math.max(0, Math.round((endTime - effNow) / 1000));

      function render() {
        var h = Math.floor(remaining / 3600);
        var m = Math.floor((remaining % 3600) / 60);
        var s = remaining % 60;
        hEl.textContent = p2(h);
        mEl.textContent = p2(m);
        sEl.textContent = p2(s);
      }

      render();
      el.hidden = false;

      var iv = setInterval(function () {
        if (remaining > 0) { remaining--; }
        render();
        if (remaining <= 0) { clearInterval(iv); el._pbmTimerIv = null; }
      }, 1000);
      el._pbmTimerIv = iv;
    }

    // Respaldo client-side del cierre: si un PoP sirvió la barra ya pasado
    // hard_end (HTML cacheado) o en preview con ?pbm_now=futuro, ocúltala.
    // El caso normal ya no la renderiza server-side (Liquid unless past_hard_end).
    function initHardEnd(bar) {
      if (bar.dataset.pbmHardInit === '1') { return; }
      bar.dataset.pbmHardInit = '1';
      var he = Date.parse(bar.getAttribute('data-hard-end'));
      if (isNaN(he)) { return; }
      if (effectiveNow() >= he) { bar.style.display = 'none'; }
    }

    function initAll(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var bars = scope.querySelectorAll('.promo-bar-mudanza[data-hard-end]');
      for (var b = 0; b < bars.length; b++) { initHardEnd(bars[b]); }
      var counters = scope.querySelectorAll('.promo-bar-mudanza__counter[data-promo-counter]');
      for (var j = 0; j < counters.length; j++) { initCounter(counters[j]); }
      var timers = scope.querySelectorAll('.promo-bar-mudanza__timer[data-promo-timer]');
      for (var t = 0; t < timers.length; t++) { initTimer(timers[t]); }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    } else {
      initAll(document);
    }

    // Theme editor: re-init solo la sección recargada.
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target || document);
    });

    // Cleanup del setInterval del timer al recargar/quitar la sección (theme editor).
    document.addEventListener('shopify:section:unload', function (e) {
      var scope = e.target && e.target.querySelectorAll ? e.target : document;
      var timers = scope.querySelectorAll('.promo-bar-mudanza__timer[data-promo-timer]');
      for (var t = 0; t < timers.length; t++) {
        if (timers[t]._pbmTimerIv) { clearInterval(timers[t]._pbmTimerIv); timers[t]._pbmTimerIv = null; }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-grid-3x1"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSkr(root) {
      if (root.dataset.skrInit === '1') return;
      root.dataset.skrInit = '1';

      function q(sel) { return root.querySelector(sel); }
      // Metafields legacy: | json puede salir doble-encodeado -> re-parsear.
      function pj(sel) {
        var el = q(sel);
        if (!el) return null;
        var d = JSON.parse(el.textContent);
        if (typeof d === 'string') { d = JSON.parse(d); }
        return d;
      }

      var data, list;
      try { data = pj('[data-skr-data]'); list = pj('[data-skr-list]'); } catch (e) { return; }
      if (!data || !list || !list.length) { return; }

      var PER = 12, page = 1, pages = Math.ceil(list.length / PER);
      var nf = new Intl.NumberFormat('es-MX');
      var MES = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
      function fdate(s) { var d = new Date(s); if (isNaN(d)) { return ''; } return d.getDate() + ' ' + MES[d.getMonth()] + ' ' + d.getFullYear(); }
      function stars(n) { var f = '', e = '', i; for (i = 0; i < 5; i++) { if (i < n) { f += '★'; } else { e += '☆'; } } return f + '<span style="color:#e8ddcf">' + e + '</span>'; }
      var CHECK = '<svg width="13" height="13" viewBox="0 0 16 16" fill="none" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="#12D385"/><path d="M4.5 8.2l2.3 2.3 4.7-4.7" stroke="#fff" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      function esc(s) { return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

      // Resumen + desglose de estrellas (desplegable). El override del setting
      // (p. ej. "4.8") manda sobre el promedio del metafield — Mau 2026-07-04:
      // alinear con el 4.8 global de la marca (el metafield redondeaba a 4.9).
      var avg = Number(root.getAttribute('data-skr-avg-override')) || Number(data.reviewAverageValue || 0);
      q('[data-skr-avg]').textContent = (Math.round(avg * 10) / 10).toFixed(1);
      q('[data-skr-count]').textContent = nf.format(data.reviewCount || list.length) + ' reseñas verificadas';
      var br = q('[data-skr-break]'), tot = 0, i;
      var starsArr = (data.stars || []).slice().sort(function (a, b) { return Number(b.star) - Number(a.star); });
      for (i = 0; i < starsArr.length; i++) { tot += Number(starsArr[i].count); }
      var bh = '';
      for (i = 0; i < starsArr.length; i++) {
        var pc = tot ? Math.max(1, Math.round(Number(starsArr[i].count) / tot * 100)) : 0;
        bh += '<div class="skr-brow"><span class="skr-brow-l">' + starsArr[i].star + ' ★</span><span class="skr-bar"><i style="width:' + pc + '%"></i></span><span class="skr-brow-c">' + nf.format(starsArr[i].count) + '</span></div>';
      }
      br.innerHTML = bh;
      var sum = q('[data-skr-sum]'), head = sum.parentElement;
      function tgl() { var on = head.classList.toggle('skr-open'); sum.setAttribute('aria-expanded', on ? 'true' : 'false'); }
      sum.addEventListener('click', tgl);
      sum.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tgl(); } });

      // Lightbox de fotos.
      var lb = q('[data-skr-lb]'), lbi = q('[data-skr-lb-img]'), lbc = q('[data-skr-lb-cap]');
      function lbOpen(src, cap) { lbi.src = src; lbc.textContent = cap; lb.classList.add('skr-on'); document.body.style.overflow = 'hidden'; }
      function lbClose() { if (!lb.classList.contains('skr-on')) return; lb.classList.remove('skr-on'); lbi.removeAttribute('src'); document.body.style.overflow = ''; }
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target.hasAttribute('data-skr-lb-x')) { lbClose(); } });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { lbClose(); } });

      // Grid (masonry por CSS columns) + paginación numerada con ventana.
      var grid = q('[data-skr-grid]');
      function render() {
        var start = (page - 1) * PER, slice = list.slice(start, start + PER), h = '', k;
        for (k = 0; k < slice.length; k++) {
          var r = slice[k], name = esc(((r.customer && r.customer.firstName) || '') + (r.customer && r.customer.lastName ? ' ' + String(r.customer.lastName).charAt(0) + '.' : '')).trim() || 'Clienta';
          var img = (r.images || []).filter(function (x) { return x.active; })[0];
          var aud = (r.audio || []).filter(function (x) { return x.active; })[0];
          var comment = esc((r.comment || '').trim());
          var long = comment.length > 190;
          h += '<div class="skr-card">';
          if (img) { h += '<img class="skr-img" loading="lazy" src="' + esc(img.src) + '" alt="Foto de la reseña de ' + name + '" data-cap="' + comment.slice(0, 160) + '">'; }
          h += '<div class="skr-body"><span class="skr-cstars">' + stars(Number(r.stars) || 5) + '</span>';
          if (aud) { h += '<audio controls preload="none" src="' + esc(aud.src) + '"></audio>'; }
          if (comment) { h += '<p class="skr-ctext' + (long ? ' skr-clamp' : '') + '">' + comment + '</p>' + (long ? '<span class="skr-more">Leer más</span>' : ''); }
          h += '<div class="skr-cfoot"><span class="skr-cname">' + name + '</span>' + CHECK + '<span class="skr-cdate">' + fdate(r.createdAt) + '</span></div></div></div>';
        }
        grid.innerHTML = h;
        renderPag();
      }
      grid.addEventListener('click', function (e) {
        if (e.target.classList.contains('skr-img')) { lbOpen(e.target.src, e.target.getAttribute('data-cap') || ''); }
        if (e.target.classList.contains('skr-more')) { var p = e.target.previousElementSibling; p.classList.remove('skr-clamp'); e.target.remove(); }
      });

      var pag = q('[data-skr-pag]');
      function pageBtns() {
        var out = [], w = 1, s = new Set([1, pages]), j;
        for (j = page - w; j <= page + w; j++) { if (j >= 1 && j <= pages) { s.add(j); } }
        var arr = Array.from(s).sort(function (a, b) { return a - b; });
        for (j = 0; j < arr.length; j++) { if (j > 0 && arr[j] - arr[j - 1] > 1) { out.push('...'); } out.push(arr[j]); }
        return out;
      }
      function renderPag() {
        if (pages < 2) { pag.innerHTML = ''; return; }
        var h = '<button data-p="prev" aria-label="Anterior" ' + (page === 1 ? 'disabled' : '') + '>&lsaquo;</button>', b = pageBtns(), j;
        for (j = 0; j < b.length; j++) {
          if (b[j] === '...') { h += '<span class="skr-dots">&hellip;</span>'; }
          else { h += '<button data-p="' + b[j] + '" class="' + (b[j] === page ? 'skr-cur' : '') + '">' + b[j] + '</button>'; }
        }
        h += '<button data-p="next" aria-label="Siguiente" ' + (page === pages ? 'disabled' : '') + '>&rsaquo;</button>';
        pag.innerHTML = h;
      }
      pag.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b || b.disabled) { return; }
        var p = b.getAttribute('data-p');
        if (p === 'prev') { page = Math.max(1, page - 1); }
        else if (p === 'next') { page = Math.min(pages, page + 1); }
        else { page = Number(p); }
        render();
        var band = q('[data-skr-band]');
        var y = band.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });

      render();
    }

    function boot(root) {
      var nodes = (root || document).querySelectorAll('[data-skr-root]');
      Array.prototype.forEach.call(nodes, initSkr);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(document); });
    } else {
      boot(document);
    }
    document.addEventListener('shopify:section:load', function (e) { boot(e.target || document); });
  })();

  } catch(e) { console.error(e); }
})();
})();
